import React from "react";
import "../../styles/components/ToolBarLeftPanel.scss";
import checkMarkGreen from "../../images/ChecjmarkGreen.svg";
import expandIcon from "../../images/ic_expand_more_24px (1).svg";
import Tooltip from "@mui/material/Tooltip";
import DraftStatus from "../../images/Draft.svg";
import CheckMarkFilled from "../../images/checkmark-filled.svg";
import CommonStatus from "../../images/common_status.svg";
import WithdrawnStatus from "../../images/withdrawn.svg";
import ExpiredStatus from "../../images/expired-status.png";
const BuisnessRuleCard = ({
  cardObj,
  handleExpandModuleClaims,
  setSelectedModule,
  mlrStatuses,
}) => {
  const statusObj = mlrStatuses?.find(
    (status) => status.targetModuleDamName === cardObj?.targetModuleDamName,
  );
  const status = statusObj ? statusObj.targetModuleMlrStatus : "Not Submitted";

  const getStatusIcon = (status) => {
    if (!status) return CommonStatus;
    switch (status.toLowerCase()) {
      case "not submitted":
      case "draft":
        return DraftStatus;
      case "available for use":
        return CheckMarkFilled;
      case "expired":
        return ExpiredStatus;
      case "pending withdrawal":
      case "withdrawn":
        return WithdrawnStatus;
      default:
        return CommonStatus;
    }
  };
  return (
    <div
      className="selected-module-cards associated-card "
      onClick={() => {
        setSelectedModule(cardObj, "childModule");
        handleExpandModuleClaims(cardObj, "childModule");
      }}
    >
      <div className="moduleCardFirstRow">
        <div className="cardInfoLeftSide">
          <Tooltip title={status}>
            <img src={getStatusIcon(status)} className="checkMarkClass" />
          </Tooltip>
          <strong className="boldText">{cardObj?.targetModuleDamName}</strong>
        </div>
        <div className="cardInfoRightSide">
          <div
            className={
              cardObj?.ruleCondition === "Optional"
                ? "optional-box"
                : "mustuse-box"
            }
          ></div>
          <div className="parentModuleText">
            {cardObj?.ruleCondition === "Optional" ? "Optional" : "Must Use"}
          </div>{" "}
          <img
            src={expandIcon}
            className="expandIcon"
            onClick={() => {
              setSelectedModule(cardObj, "childModule");
              handleExpandModuleClaims(cardObj, "childModule");
            }}
          />
        </div>
      </div>
      <div className="moduleCardsRow">
        <div className="infoText">Brand :</div>
        {/* <div className="colonClass">:</div> */}
        <span className="nameBrandText">
          {""}
          {cardObj?.productName}
        </span>
      </div>
      <div className="moduleCardsRow">
        <div className="infoText">Name : </div>
        {/* <div className="colonClass">:</div> */}
        <span className="nameBrandText">
          {cardObj?.targetModuleName ? (
            <Tooltip title={cardObj.targetModuleName}>
              <span>
                {cardObj.targetModuleName.length > 20
                  ? cardObj.targetModuleName.slice(0, 20) + "..."
                  : cardObj.targetModuleName}
              </span>
            </Tooltip>
          ) : (
            <span>-</span>
          )}
        </span>
      </div>
    </div>
  );
};
export default BuisnessRuleCard;
